var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{attrs:{"route":_vm.getModuleRoute,"addProperties":{
    eventType: 1,
    routeToCreate: _vm.getModuleRoute,
  },"tableProperties":_vm.tableProperties,"exportProperties":{
    pdf: {
      filename: `${_vm.$t('common_words.farms')}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t('common_words.farms')}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  }},on:{"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue,"refresh":_vm.refresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }